import { render, staticRenderFns } from "./FixSmsSops.vue?vue&type=template&id=147a2520&scoped=true"
import script from "./FixSmsSops.vue?vue&type=script&lang=js"
export * from "./FixSmsSops.vue?vue&type=script&lang=js"
import style0 from "./FixSmsSops.vue?vue&type=style&index=0&id=147a2520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a2520",
  null
  
)

export default component.exports